import { ReactNode } from "react";
import styles from './BannerArrow.module.css'
import arrowBacground from './image/arrowBacground.png'
import arrowBacgroundTransition from './image/arrowBacgroundTransition.png'

export const BannerArrow = ({children}:{children:ReactNode}) =>{
    return (
        <div className={styles.banner_arrow_container}>
            <img src={arrowBacground} className={styles.banner_arrow_bacgroung_image_up}/>
            <div className={styles.banner_arrow_content}>
                {children}
            </div>
            <img src={arrowBacgroundTransition} className={styles.banner_arrow_bacgroung_image_down}/>
        </div>
    )
}